// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3rKcl","colCheckbox":"styles_colCheckbox__2WHG1"};